import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getOneRosterUser } from "../../../store/OneRoster/OneRosterUserAction";
import StatusCode from "../../../util/StatusCode";
import TableVertical from "../../misc/TableVertical";
import { CoreOneRosterUser } from "../../../models/CoreOneRosterModels";
import { RequestState } from "../../../models/RequestState";
import * as Helper from '../../../util/Helper';
import { useTranslation } from 'react-i18next';
import { RootState } from "../../../store/store";


const OneRosterUserInfo = () => {
    const { t } = useTranslation(['common', 'oneRoster']);

    const { userId } = useParams();
    const dispatch = useDispatch();
    const user = useSelector<RootState, RequestState<CoreOneRosterUser>>(state => state.onerosterUser.user);

    useEffect(() => {
        if (userId) {
            getOneRosterUser(userId)(dispatch);
        }
    }, [dispatch, userId]);

    const renderUserInfo = () => {
        let userInfo = [];
        if (user.code === StatusCode.COMPLETE) {
            const u = user.data;
            userInfo.push(
                { header: t('genericTableHeaders.name', { ns: 'common' }), content: `${u.givenName} ${u.familyName}` },
                { header: t('commonTableHeaders.sisId', { ns: 'oneRoster' }), content: u.id },
                { header: t('genericTableHeaders.active', { ns: 'common' }), content: Helper.active(u.active) },
                { header: t('commonTableHeaders.userName', { ns: 'oneRoster' }), content: u.userName },
                { header: t('commonTableHeaders.email', { ns: 'oneRoster' }), content: u.email },
                { header: t('commonTableHeaders.role', { ns: 'oneRoster' }), content: t(`roleTypes.${u.role}`, { ns: 'oneRoster' }) },
                { header: t('genericTableHeaders.created', { ns: 'common' }), content: Helper.formatDate(u.created), classname: 'nowrap' },
                { header: t('genericTableHeaders.modified', { ns: 'common' }), content: Helper.formatDate(u.modified), classname: 'nowrap' },
            );
        }
        return (
            <TableVertical
                header={t('commonTableHeaders.information', { ns: 'oneRoster' })}
                info={userInfo}
                error={user.code === StatusCode.ERROR}
                searching={user.code === StatusCode.PENDING}
            />
        )
    }

    return (<>
        {renderUserInfo()}
    </>)
}

export default OneRosterUserInfo;
